import { createUseStyles } from "react-jss";
const useStyles = createUseStyles((_) => ({
  containerText: {
    padding: "19px 15px 29px 15px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
}));

export default useStyles;
